/** YouTube embed paths (no watch URL) — matches post-purchase embed pattern (?rel=0). */
export const EXISTING_SITE_STORE_READY_VIDEO_MARGIN_ID = 'MfhCkPEhi5A';
export const EXISTING_SITE_STORE_READY_VIDEO_DELIVERY_ID = 'naSgKuTL1xI';

export function buildYoutubeEmbedSrc(videoId: string): string {
  return `https://www.youtube.com/embed/${videoId}?rel=0`;
}
